import React from 'react';
import { string, bool, func } from 'prop-types';
import {
  Button,
  CircularProgress,
} from '@material-ui/core';

import {
  withMeetingContext,
  MeetingContextMeetingControlsProps,
} from 'Scenes/_root/meetingContext';
import styles from './styles.scss';

export const InMeeting = (props) => {
  const {
    consultGuid,
    isEndingMeeting,
    meetingEnd,
    meetingControls,
  } = props;
  return (
    <React.Fragment>
      <div className={styles.inMeetingWrapper}>
        <div className={styles.buttonWrapper}>
          <Button
            fullWidth
            color='primary'
            disabled={isEndingMeeting}
            onClick={() => {
              meetingEnd(consultGuid).then(() => {
                meetingControls.stop();
              });
            }}
            variant='contained'
          >
            End consult
          </Button>
          { isEndingMeeting && <CircularProgress className={styles.buttonProgress} size={24} /> }
        </div>
      </div>
    </React.Fragment>
  );
};

const MapStateProps = {
  consultGuid: string.isRequired,
  isEndingMeeting: bool.isRequired,
};

const MapDispatchProps = {
  meetingEnd: func.isRequired,
};

InMeeting.propTypes = {
  meetingControls: MeetingContextMeetingControlsProps,
  ...MapStateProps,
  ...MapDispatchProps,
};

export default withMeetingContext(['meetingControls'])(InMeeting);
